import { FC } from 'react';

type Props = {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
};

export const Card: FC<Props> = ({ title, icon, children }) => {
  return (
    <div className="w-fit bg-white border border-solid border-grey-100 rounded-xl p-6 flex flex-col gap-y-6">
      <div className="flex flex-row gap-x-4 items-center">
        {icon}
        <div className="font-medium">{title}</div>
      </div>
      {children}
    </div>
  );
};
